import type { EvaluationContext } from '@openfeature/web-sdk';
import type { LDContext, LDSingleKindContext } from 'launchdarkly-js-client-sdk';

const LD_BUILT_IN_ATTRS = new Set([
  'name',
  'firstName',
  'lastName',
  'email',
  'anonymous',
  'ip',
  'country',
  'avatar',
  'secondary',
]);

export const translateContext = (ctx: EvaluationContext): LDContext => {
  const { targetingKey, kind, ...rest } = ctx;
  const builtIns = Object.fromEntries(
    Object.entries(rest).filter(([k]) => LD_BUILT_IN_ATTRS.has(k)),
  );
  const custom = Object.fromEntries(
    Object.entries(rest).filter(([k]) => !LD_BUILT_IN_ATTRS.has(k)),
  );
  const key = targetingKey != null ? String(targetingKey) : 'anonymous';
  return {
    kind: typeof kind === 'string' ? kind : 'user',
    key,
    ...(targetingKey == null ? { anonymous: true } : {}),
    ...builtIns,
    ...(Object.keys(custom).length > 0 ? { custom } : {}),
  } as LDSingleKindContext;
};
